/**
 * O que cada recado do service worker invalida no cache das abas abertas. Fica fora do `main.tsx`
 * para ser testado sem montar o app; o `main.tsx` só liga o listener a `invalidateOnPush`.
 */
import type { QueryClient, QueryKey } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';
import { PUSH_MESSAGE_TYPE, type PushMessageType, isPushMessage } from '~/push/notification';

/**
 * A nota invalida as notas; o post e o lembrete, os documentos, que cobrem o feed, as pastas e as
 * guias de cada situação (`queryKeys.documents.guides`).
 */
export const INVALIDATED_BY_PUSH: Record<PushMessageType, QueryKey> = {
  [PUSH_MESSAGE_TYPE.invoice]: queryKeys.invoices.all,
  [PUSH_MESSAGE_TYPE.documentPost]: queryKeys.documents.all,
  [PUSH_MESSAGE_TYPE.guideReminder]: queryKeys.documents.all,
};

/** Invalida o que o push mudou; uma mensagem que não é recado de push não muda nada. */
export async function invalidateOnPush(queryClient: QueryClient, data: unknown): Promise<void> {
  if (!isPushMessage(data)) return;
  await queryClient.invalidateQueries({ queryKey: INVALIDATED_BY_PUSH[data.type] });
}
